<template>
  <svg viewBox="0 0 136 136" fill="none">
    <g clip-path="url(#clip0_624_7)">
      <g mask="url(#mask0_624_7)">
        <g clip-path="url(#clip1_624_7)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 68C0 32.1015 29.1015 3 65 3V68H0Z"
            fill="url(#paint0_radial_624_7)" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 133C0 97.1015 29.1015 68 65 68V133H0Z"
            fill="url(#paint1_radial_624_7)" />
          <path
            d="M97.5 68C115.449 68 130 53.4493 130 35.5C130 17.5507 115.449 3 97.5 3C79.5507 3 65 17.5507 65 35.5C65 53.4493 79.5507 68 97.5 68Z"
            fill="url(#paint2_radial_624_7)" />
          <path d="M97.5 100.5L65 68H130V133L97.5 100.5Z" fill="url(#paint3_radial_624_7)" />
        </g>
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_624_7"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(65 68) rotate(-126.235) scale(84.4532)">
        <stop stop-color="currentColor" />
        <stop offset="1" stop-color="currentColor" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_624_7"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57.72 74.24) rotate(132.968) scale(90.5525)">
        <stop stop-color="currentColor" />
        <stop offset="1" stop-color="currentColor" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_624_7"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(118.95 56.17) rotate(-133.901) scale(63.3826)">
        <stop stop-color="currentColor" />
        <stop offset="1" stop-color="currentColor" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_624_7"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(130 68) rotate(129.877) scale(51.4709)">
        <stop stop-color="currentColor" />
        <stop offset="1" stop-color="currentColor" />
      </radialGradient>
      <clipPath id="clip0_624_7">
        <rect width="136" height="136" fill="white" />
      </clipPath>
      <clipPath id="clip1_624_7">
        <rect width="130" height="130" fill="white" transform="translate(0 0)" />
      </clipPath>
    </defs>
  </svg>
</template>
